import { render, staticRenderFns } from "./BgImgDialog.vue?vue&type=template&id=335f05e5&scoped=true"
import script from "./BgImgDialog.vue?vue&type=script&lang=js"
export * from "./BgImgDialog.vue?vue&type=script&lang=js"
import style0 from "./BgImgDialog.vue?vue&type=style&index=0&id=335f05e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f05e5",
  null
  
)

export default component.exports